import React, { useState } from "react";

const PropertyFilters = () => {
  const [activeTab, setActiveTab] = useState("Buy");
  const [selectedBHK, setSelectedBHK] = useState("All");

  const tabs = ["Buy", "Rent"];
  const bhkOptions = ["All", "2 BHK", "3 BHK", "4 BHK"];

  return (
    <div className="bg-white p-6 ">
      {/* Header */}
      <h2 className="text-lg font-semibold text-gray-800 mb-3">
        Properties in Manglam Aananda
      </h2>

      {/* Tab Section */}
      <div className="flex border-b">
        {tabs.map((tab) => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={`px-6 py-2 text-lg font-medium ${
              activeTab === tab
                ? "border-b-2 border-red-500 text-black"
                : "text-gray-500"
            }`}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* BHK Selection */}
      <div className="bg-gray-100 p-3 mt-3 flex space-x-3 rounded-md">
        {bhkOptions.map((bhk) => (
          <button
            key={bhk}
            onClick={() => setSelectedBHK(bhk)}
            className={`px-4 py-1 rounded-full border ${
              selectedBHK === bhk
                ? "border-teal-500 text-teal-600 font-semibold bg-white shadow"
                : "border-gray-300 text-gray-600"
            }`}
          >
            {bhk}
          </button>
        ))}
      </div>
    </div>
  );
};

export default PropertyFilters;
